// extracted by mini-css-extract-plugin
module.exports = {"title":"LabelTypes_title__cgE34","description":"LabelTypes_description__19tug","config":"LabelTypes_config__tpe1B"};